import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1>Privacy Policy</h1>
          <p>Ultimo aggiornamento: 29 giugno 2026</p>
        </div>

        <section>
          <h2>Titolare del trattamento</h2>
          <p>
            StudioInsieme raccoglie e tratta i dati forniti dalle famiglie per gestire richieste di contatto,
            iscrizioni, percorsi di doposcuola e pagamenti collegati ai servizi educativi.
          </p>
        </section>

        <section>
          <h2>Dati raccolti</h2>
          <p>
            Possiamo raccogliere nome del genitore, email, telefono, nome ed età dello studente, classe frequentata,
            informazioni sulle esigenze scolastiche e messaggi inviati tramite i moduli del sito.
          </p>
        </section>

        <section>
          <h2>Finalità</h2>
          <p>
            I dati sono utilizzati per rispondere alle richieste, organizzare il servizio, proporre il percorso più
            adatto, gestire iscrizioni e comunicazioni con la famiglia. I pagamenti sono elaborati tramite Stripe.
          </p>
        </section>

        <section>
          <h2>Studenti minorenni</h2>
          <p>
            Il servizio è rivolto a famiglie con bambini e ragazzi. Le informazioni relative agli studenti minorenni
            sono raccolte tramite il genitore o tutore e usate solo per finalità educative e organizzative.
          </p>
        </section>

        <section>
          <h2>Conservazione e diritti</h2>
          <p>
            I dati vengono conservati per il tempo necessario alla gestione del servizio e degli obblighi amministrativi.
            È possibile richiedere accesso, rettifica o cancellazione dei dati scrivendo tramite la pagina contatti.
          </p>
        </section>

        <div className="legal-actions">
          <Button asChild className="btn-primary">
            <Link to="/contatti">Contattaci</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/">Torna alla home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
